module.exports = __webpack_public_path__ + "img/activity.d70dc3d0.svg";